<!-- This should go into a new component in shared module, a similar dropdown is also being used in tv-v1.component -->

<div class="btn-group {{theme$ | async}}">
  @if (options) {
    <lib-select
      [options]="options"
      [label]="'BUTTONS.EXPORT' |translate"
      [border]="'custom-border'"
      [classes]="'font-size-normal-small text-primary h-100 text-left'"
      [withIcon]="true"
      [notBold]="true"
      [fullWidth]="true"
      [itemClasses]="'font-size-normal-small'"
      [doNotTranslate]="true"
      [container]="''"
      [disabled]="buttonDisabled"
      [size]="'small'"
      (selectedChanged)="onDropdownSelected($event)">
      <ng-container icon>
        <i class="far fa-download font-icons pointer mr-2"></i>
        <span class="pointer" > {{ (customLabel || 'BUTTONS.EXPORT') | translate}} </span>
      </ng-container>
    </lib-select>
  }
</div>
